import api from "../../utils/authFetch";

export const getUserDahsa = async({userId, startYear = 2025, endYear = 2026, userCurrentTimezone})=> {
     try {
        const res = await api.post(`/worker/admin/dasha/chara-dasha`, {
          userId,startYear, endYear, userCurrentTimezone
        });
        return res.data;
      } catch (err) {
        console.error("Get user dasha chart error:", err?.response?.data || err.message);
        throw err?.response?.data || null;
      }
}